module.exports = __webpack_public_path__ + "static/Smiths_pin_hover-a33e07f213479b08809104ae40c63eee.png";